import { render } from "./ConsumerFooter.vue?vue&type=template&id=14d29927&scoped=true"
import script from "./ConsumerFooter.vue?vue&type=script&lang=js"
export * from "./ConsumerFooter.vue?vue&type=script&lang=js"

import "./ConsumerFooter.vue?vue&type=style&index=0&id=14d29927&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-14d29927"]])

export default __exports__